import {
  BookA,
  BookOpen,
  Package,
  FolderTree,
  Home,
  PackageCheck,
  ShieldCheck,
  Truck,
  Users,
  ShoppingCart,
  Tag,
  User,
  Percent,
  MessageCircle,
  Trash,
  DollarSign,
  Bell,
  Image,
  Mail,
  LayoutGrid,
  Layers,
  Clapperboard,
  Sparkles,
} from "lucide-react";

export function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

export const nonNumericRegex = /^[A-Za-z\s]+$/;
export const sidebarData = [
  {
    id: 1,
    mainTitle: "",
    menu: [
      {
        id: 1,
        title: "Dashboard",
        link: "/administration/dashboard",
        icon: <Home />,
        subMenu: [],
      },
    ],
  },
  {
    id: 1,
    mainTitle: "Order",
    menu: [
      {
        id: 1,
        title: "Order",
        link: "/administration/order",
        icon: <ShoppingCart />,
        subMenu: [],
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Product",
    menu: [
      {
        id: 1,
        title: "Product",
        link: "/administration/product",
        icon: <LayoutGrid />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Category",
        link: "/administration/category",
        icon: <Tag />,
        subMenu: [],
      },
      {
        id: 3,
        title: "SubCategory",
        link: "/administration/subcategory",
        icon: <FolderTree />,
        subMenu: [],
      },
      {
        id: 4,
        title: "Collection",
        link: "/administration/collection",
        icon: <Layers />,
        subMenu: [],
      },
    ],
  },
  {
    id: 3,
    mainTitle: "User",
    menu: [
      {
        id: 1,
        title: "User",
        link: "/administration/user",
        icon: <User />,
        subMenu: [],
      },
    ],
  },
  {
    id: 4,
    mainTitle: "Other",
    menu: [
      {
        id: 1,
        title: "Promocode",
        link: "/administration/promocode",
        icon: <Percent />,
        subMenu: [],
      },
      {
        id: 2,
        title: "Message",
        link: "/administration/message",
        icon: <MessageCircle />,
        subMenu: [],
      },
      {
        id: 3,
        title: "Delete Request",
        link: "/administration/delete-request",
        icon: <Trash />,
        subMenu: [],
      },
      {
        id: 4,
        title: "Refund Request",
        link: "/administration/refund-request",
        icon: <DollarSign />,
        subMenu: [],
      },
    ],
  },
  {
    id: 5,
    mainTitle: "Content Management",
    menu: [
      {
        id: 5,
        title: "Slider",
        link: "/administration/slider",
        icon: <Image />,
        subMenu: [],
      },
      {
        id: 7,
        title: "Styling",
        link: "/administration/styling",
        icon: <Clapperboard />,
        subMenu: [],
      },
      {
        id: 8,
        title: "New Arrivals",
        link: "/administration/new-arrivals",
        icon: <Sparkles />,
        subMenu: [],
      },
      {
        id: 5,
        title: "Notification",
        link: "/administration/notification",
        icon: <Bell />,
        subMenu: [],
      },
      {
        id: 6,
        title: "News Letter",
        link: "/administration/newsletter",
        icon: <Mail />,
        subMenu: [],
      },
    ],
  },
];
export const features = [
  {
    icon: <Truck className="feature-icon" />,
    title: "Free Standard Delivery",
    description:
      "There many variations of passagest Lorem Ipsum available, but the majority.",
  },
  {
    icon: <PackageCheck className="feature-icon" />,
    title: "Free In Store Returns",
    description:
      "There many variations of passagest Lorem Ipsum available, but the majority.",
  },
  {
    icon: <ShieldCheck className="feature-icon" />,
    title: "100% Secure Checkout",
    description:
      "There many variations of passagest Lorem Ipsum available, but the majority.",
  },
];

export const taxArr = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 3,
    label: "3%",
  },
  {
    value: 5,
    label: "5%",
  },
  {
    value: 12,
    label: "12%",
  },
  { value: 18, label: "18%" },
  { value: 28, label: "28%" },
];
